// extracted by mini-css-extract-plugin
export default {"Scheduler":"Scheduler_Scheduler__g70tF","InactiveTabs":"Scheduler_InactiveTabs__h9xMY"};